// Crie um novo componente, ex: SocialLoginCallback.jsx
import React, { useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import useAuth from '../../hooks/useAuth'; // Seu hook de autenticação

const SocialLoginCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { login } = useAuth();

  useEffect(() => {
    const token = searchParams.get('token');
    const userJson = searchParams.get('user');

    if (token && userJson) {
      localStorage.setItem('token', token);
      const userData = JSON.parse(decodeURIComponent(userJson));
      
      // Use sua função de login do useAuth para atualizar o estado global
      login(userData, '/dashboard'); // A função login já navega
    } else {
      // Houve um erro, redireciona de volta para a tela de login
      navigate('/login?error=social_login_failed');
    }
  }, [searchParams, navigate, login]);

  return (
    <div className="loading-fullscreen">
      <div className="spinner"></div>
      <p>Finalizando login...</p>
    </div>
  );
};

export default SocialLoginCallback;